import { render, staticRenderFns } from "./RequestDocument.vue?vue&type=template&id=dc5fa132"
import script from "./RequestDocument.vue?vue&type=script&lang=js"
export * from "./RequestDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports